module.exports = __webpack_public_path__ + "static/media/headerLogo.1517a904.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DGR/Header/headerLogo.png
// module id = 704
// module chunks = 0